import React, { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { motion } from "framer-motion";
import { UserCheck, Clock, AlertCircle } from "lucide-react";

export default function AdminImpersonationsPage() {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const { api } = useAuth();

    useEffect(() => {
        api.get("/v2/admin/impersonations").then(r => setEvents(r.data.events)).catch(console.error).finally(() => setLoading(false));
    }, []);

    return (
        <div className="p-8" data-testid="admin-impersonations">
            <div className="mb-8">
                <h1 className="text-2xl font-display font-bold text-white">View-as-User Audit</h1>
                <p className="text-sm text-gray-500 mt-1">All "View as user" sessions are logged permanently. Trigger a new session from the <span className="text-gray-400">Users</span> page.</p>
            </div>

            {events.length === 0 && !loading ? (
                <div className="bg-card border border-border/40 p-8 text-center">
                    <UserCheck className="w-8 h-8 text-gray-700 mx-auto mb-3" />
                    <p className="text-sm text-gray-500">No view-as sessions recorded yet.</p>
                    <p className="text-xs text-gray-600 mt-1">Go to the Users page → click "View as" on any user to start one.</p>
                </div>
            ) : (
                <div className="space-y-3">
                    {events.map((ev, i) => (
                        <motion.div key={ev.id} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.03 }}
                            className="bg-card border border-border/40 p-5">
                            <div className="flex items-start justify-between">
                                <div className="flex items-center gap-3">
                                    <div className={`w-2 h-2 rounded-full ${ev.is_active ? "bg-yellow-400 animate-pulse" : "bg-gray-600"}`} />
                                    <div>
                                        <p className="text-sm text-white"><span className="text-gray-400">{ev.admin_name}</span> viewed as <span className="font-semibold">{ev.target_name}</span></p>
                                        <p className="text-xs text-gray-600 mt-0.5">{ev.target_email} ({ev.target_role})</p>
                                    </div>
                                </div>
                                <div className="text-right">
                                    <p className="text-xs text-gray-600 font-mono">{ev.started_at?.slice(0, 19).replace("T", " ")}</p>
                                    {ev.ended_at && <p className="text-xs text-gray-700 font-mono">ended {ev.ended_at?.slice(11, 19)}</p>}
                                    {ev.is_active && <span className="text-xs text-yellow-400">Active now</span>}
                                </div>
                            </div>
                            <div className="mt-3 pl-5 border-l border-border/40">
                                <p className="text-xs text-gray-500"><span className="text-gray-600">Reason:</span> {ev.reason}</p>
                            </div>
                        </motion.div>
                    ))}
                </div>
            )}
        </div>
    );
}
